import React from "react";
import { Link } from "react-router-dom";

function MarketingHeroo() {
  return (
    <div
      id="khalif-breadcrumb-wrap"
      className="khalif-breadcrumb-wrap breadcrumb-bg text-center d-flex align-items-center avatar"
      style={{ backgroundImage: `url('/assets/img/Marketing2.jpg')` }}
    >
      <div className="container">
        <div className="row">
          <div className="offset-xl-2 col-xl-8">
            <div className="khalif-breadcrumb-content">
              <h2>Marketing</h2>
              <ul className="breadcrumb justify-content-center">
                <li className="breadcrumb-item">
                  <Link to="/" title="Home">
                    Home /
                  </Link>
                </li>
                <li className="breadcrumb-item active">Case Studies</li>
              </ul>
              <p>
                In a recent marketing case study, we boosted online visibility
                and lead generation through targeted ad campaigns and website
                optimization.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MarketingHeroo;
